import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeteleteProductHoverIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.78467 5.49984C3.78467 5.31574 3.93391 5.1665 4.118 5.1665H13.118C13.3021 5.1665 13.4513 5.31574 13.4513 5.49984V14.4998C13.4513 14.8535 13.3109 15.1926 13.0608 15.4426C12.8108 15.6927 12.4716 15.8332 12.118 15.8332H5.118C4.76438 15.8332 4.42524 15.6927 4.17519 15.4426C3.92514 15.1926 3.78467 14.8535 3.78467 14.4998V5.49984ZM4.45133 5.83317V14.4998C4.45133 14.6766 4.52157 14.8462 4.6466 14.9712C4.77162 15.0963 4.94119 15.1665 5.118 15.1665H12.118C12.2948 15.1665 12.4644 15.0963 12.5894 14.9712C12.7144 14.8462 12.7847 14.6766 12.7847 14.4998V5.83317H4.45133Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.118 8.1665C7.3021 8.1665 7.45133 8.31574 7.45133 8.49984V12.4998C7.45133 12.6839 7.3021 12.8332 7.118 12.8332C6.93391 12.8332 6.78467 12.6839 6.78467 12.4998V8.49984C6.78467 8.31574 6.93391 8.1665 7.118 8.1665Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.118 8.1665C10.3021 8.1665 10.4513 8.31574 10.4513 8.49984V12.4998C10.4513 12.6839 10.3021 12.8332 10.118 12.8332C9.93391 12.8332 9.78467 12.6839 9.78467 12.4998V8.49984C9.78467 8.31574 9.93391 8.1665 10.118 8.1665Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.6601 1.36957C14.6984 1.54964 14.5834 1.72665 14.4034 1.76492L1.68737 4.46759C1.5073 4.50586 1.33029 4.39091 1.29202 4.21084C1.25375 4.03076 1.3687 3.85376 1.54877 3.81549L14.2648 1.11282C14.4448 1.07455 14.6218 1.1895 14.6601 1.36957Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.95816 0.196128C9.30399 0.122626 9.66486 0.189491 9.9614 0.382018C10.2578 0.574476 10.4657 0.876751 10.5394 1.22241C10.5394 1.22254 10.5394 1.22228 10.5394 1.22241L10.75 2.19999C10.7686 2.28656 10.7521 2.377 10.7039 2.45133C10.6558 2.52567 10.5801 2.5778 10.4934 2.59622L5.60278 3.63622C5.42308 3.67444 5.24634 3.56005 5.20761 3.38046L4.99694 2.4038C4.96017 2.23224 4.95754 2.05469 4.98936 1.88215C5.02118 1.70961 5.08674 1.54504 5.18228 1.39789C5.27782 1.25074 5.40147 1.12389 5.54613 1.02461C5.69072 0.925384 5.85346 0.855655 6.02504 0.819416C6.02512 0.819398 6.02496 0.819433 6.02504 0.819416L8.95816 0.196128C8.95816 0.196127 8.95815 0.196129 8.95816 0.196128ZM9.09673 0.848234L6.1634 1.47157C6.07756 1.48968 5.99568 1.52465 5.92335 1.57429C5.85102 1.62393 5.7892 1.68735 5.74143 1.76093C5.69366 1.83451 5.66088 1.91679 5.64497 2.00306C5.62907 2.08926 5.63033 2.17775 5.64867 2.26347C5.64868 2.26353 5.64865 2.2634 5.64867 2.26347L5.78921 2.91501L10.0279 2.01365L9.88759 1.36237L9.88741 1.36156C9.85061 1.18865 9.74665 1.03744 9.59837 0.941174C9.4501 0.844909 9.26965 0.811481 9.09673 0.848234Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgDeteleteProductHoverIcon);
export default ForwardRef;
